import { RightOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Collapse,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
  Typography,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FaStarOfLife } from 'react-icons/fa6';
import { useDispatch, useSelector } from 'react-redux';
import {
  getLinkedAccount,
  getProductConfiguration,
  getStackHolderAccount,
  updateProductConfiguration,
} from '../../Actions/RazorpaySplittingAction';
import { updateProductConfigurationSchema } from '../../Utils/Schema';
import { yupResolver } from '@hookform/resolvers/yup';

const UpdateProductConfiguration = ({ next, prev, activeKey }) => {
  const {
    handleSubmit,
    formState: { errors, isDirty, dirtyFields },
    control,
    reset,
    setValue,
    clearErrors,
  } = useForm({
    defaultValues: {
      account_number: '',
      ifsc_code: '',
      beneficiary_name: '',
    },
    resolver: yupResolver(updateProductConfigurationSchema),
  });
  const dispatch = useDispatch();

  const {
    restaurant,
    allProductConfigurationData,
    allStackHolderData,
    allLinkedAccountData,
    isUpdateProductionConfigurationtLoading,
    isGetProductConfigurationLoading,
    isGetStackHolderAccountLoading,
    isGetLinkedAccountLoading,
  } = useSelector((state) => {
    const {
      allProductConfigurationData,
      allStackHolderData,
      allLinkedAccountData,
      isUpdateProductionConfigurationtLoading,
      isGetProductConfigurationLoading,
      isGetLinkedAccountLoading,
      isGetStackHolderAccountLoading,
    } = state.razorpaySplitting;
    const { restaurant } = state.restaurant;
    return {
      restaurant,
      allProductConfigurationData,
      allStackHolderData,
      allLinkedAccountData,
      isGetLinkedAccountLoading,
      isUpdateProductionConfigurationtLoading,
      isGetProductConfigurationLoading,
      isGetStackHolderAccountLoading,
    };
  });

  const disabledFormData =
    !allLinkedAccountData?.id ||
    !allStackHolderData?.items?.[0]?.id ||
    allProductConfigurationData?.active_configuration?.settlements
      ?.account_number;

  const prevLoadingRef = useRef({
    linked: isGetLinkedAccountLoading,
    stackHolder: isGetStackHolderAccountLoading,
  });

  useEffect(() => {
    const linkedFinished =
      prevLoadingRef.current.linked === true &&
      isGetLinkedAccountLoading === false;
    const stackFinished =
      prevLoadingRef.current.stackHolder === true &&
      isGetStackHolderAccountLoading === false;

    prevLoadingRef.current = {
      linked: isGetLinkedAccountLoading,
      stackHolder: isGetStackHolderAccountLoading,
    };

    if (activeKey === '3') {
      if (
        stackFinished &&
        (allStackHolderData?.items?.length === 0 ||
          !allStackHolderData?.items?.[0]?.id)
      ) {
        message.error('Please create Stack holder account first');
      }

      if (
        linkedFinished &&
        !allLinkedAccountData?.id &&
        !restaurant?.payment_splitting?.linked_account_id
      ) {
        message.error('Please create Linked account first');
      }
    }
  }, [
    activeKey,
    isGetLinkedAccountLoading,
    isGetStackHolderAccountLoading,
    allLinkedAccountData?.id,
    allStackHolderData?.items,
  ]);

  useEffect(() => {
    dispatch(getStackHolderAccount());
    dispatch(getLinkedAccount());
    dispatch(getProductConfiguration());
  }, []);

  useEffect(() => {
    if (allProductConfigurationData) {
      reset({
        account_number:
          allProductConfigurationData?.active_configuration?.settlements
            ?.account_number,
        ifsc_code:
          allProductConfigurationData?.active_configuration?.settlements
            ?.ifsc_code,
        beneficiary_name:
          allProductConfigurationData?.active_configuration?.settlements
            ?.beneficiary_name,
      });
    }
  }, [allProductConfigurationData, reset]);

  const [checkedValueActive, setCheckedValueActive] = useState(false);

  const handleUpdateProductConfiguration = (data) => {
    const cleanedData = {
      product_configuration: {
        settlements: {
          account_number: data.account_number || null,
          ifsc_code: data.ifsc_code || null,
          beneficiary_name: data.beneficiary_name || null,
          // tnc_accepted: checkedValueActive,
        },
      },
    };
    dispatch(
      updateProductConfiguration(
        cleanedData,
        successUpdateProductConfiguration,
        failureUpdateProductConfiguration
      )
    );
  };

  const successUpdateProductConfiguration = (res) => {
    dispatch(getProductConfiguration());
    setTimeout(() => {
      message.success('Product configuration created successfully');
    }, 1000);
  };

  const failureUpdateProductConfiguration = (error) => {
    let errorMessage =
      error?.error?.error?.description ||
      error?.error?.description ||
      error?.error?.error ||
      error?.error ||
      error?.message ||
      'Something went wrong.';

    if (typeof errorMessage === 'object') {
      errorMessage = errorMessage.error || JSON.stringify(errorMessage);
    }
    setTimeout(() => {
      message.error(errorMessage);
    }, 1000);
  };

  const onChangeActive = () => {
    setCheckedValueActive(!checkedValueActive);
  };
  return (
    <>
      <form onSubmit={handleSubmit(handleUpdateProductConfiguration)}>
        <Spin
          spinning={
            isGetProductConfigurationLoading ||
            isUpdateProductionConfigurationtLoading
          }
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Typography className='formHeading'>
                Update a product configurations
              </Typography>
            </Col>
            <Col span={24}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Row gutter={[10, 16]}>
                    <Col span={24}>
                      <Typography
                        className='formHeading'
                        style={{ marginBottom: '-15px' }}
                      >
                        Account{' '}
                        <FaStarOfLife
                          style={{
                            fontSize: '7px',
                            color: '#eb5757',
                            position: 'absolute',
                            top: '7%',
                            marginLeft: '2px',
                          }}
                        />
                      </Typography>
                    </Col>
                    <Col span={24}>
                      <Controller
                        name='account_number'
                        control={control}
                        className='inputLabel'
                        as={<Input size='large' disabled={disabledFormData} />}
                      />
                      {errors.account_number && (
                        <p className='errorMessage'>
                          {errors.account_number.message}
                        </p>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <Row gutter={[10, 16]}>
                    <Col span={24}>
                      <Typography
                        className='formHeading'
                        style={{ marginBottom: '-15px' }}
                      >
                        IFSC number
                        <FaStarOfLife
                          style={{
                            fontSize: '7px',
                            color: '#eb5757',
                            position: 'absolute',
                            top: '7%',
                            marginLeft: '2px',
                          }}
                        />
                      </Typography>
                    </Col>
                    <Col span={24}>
                      <Controller
                        name='ifsc_code'
                        control={control}
                        className='inputLabel'
                        as={<Input size='large' disabled={disabledFormData} />}
                      />
                      {errors.ifsc_code && (
                        <p className='errorMessage'>
                          {errors.ifsc_code.message}
                        </p>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row gutter={[10, 16]}>
                    <Col span={24}>
                      <Typography
                        className='formHeading'
                        style={{ marginBottom: '-15px' }}
                      >
                        Beneficiary Name
                        <FaStarOfLife
                          style={{
                            fontSize: '7px',
                            color: '#eb5757',
                            position: 'absolute',
                            top: '7%',
                            marginLeft: '2px',
                          }}
                        />
                      </Typography>
                    </Col>
                    <Col span={24}>
                      <Controller
                        name='beneficiary_name'
                        control={control}
                        className='inputLabel'
                        as={<Input size='large' disabled={disabledFormData} />}
                      />
                      {errors.beneficiary_name && (
                        <p className='errorMessage'>
                          {errors.beneficiary_name.message}
                        </p>
                      )}
                    </Col>
                  </Row>
                </Col>
                {/* <Col span={24}>
                <Row gutter={[10, 16]}>
                  <Col span={16}>
                    <Typography
                      className='formHeading'
                      style={{ marginBottom: '-15px' }}
                    >
                      Do you accept the Terms and Conditions?
                      <FaStarOfLife
                        style={{
                          fontSize: '7px',
                          color: '#eb5757',
                          position: 'absolute',
                          top: '7%',
                          marginLeft: '2px',
                        }}
                      />
                    </Typography>
                  </Col>
                  <Col span={8}>
                    <Controller
                      name='email'
                      control={control}
                      className='inputLabel'
                      render={() => (
                        <Radio.Group
                        onChange={onChangeActive}
                        value={checkedValueActive}
                        >
                          <Radio className='textRadio' value={true}>
                            Yes
                          </Radio>
                          <Radio className='textRadio' value={false}>
                            No
                          </Radio>
                        </Radio.Group>
                      )}
                    />
                  </Col>
                </Row>
              </Col> */}
              </Row>
            </Col>
          </Row>
          <Col span={24} style={{ marginTop: '40px' }}>
            <Row gutter={[16, 16]} className='button' justify='center'>
              <Col xl={6} lg={6} md={8} sm={12} xs={12}>
                <Button className='detailsButton' size='large' onClick={prev}>
                  Previous
                </Button>
              </Col>
              <Col xl={6} lg={6} md={8} sm={12} xs={12}>
                <Button
                  className={disabledFormData ? 'classButton' : 'detailsButton'}
                  htmlType='submit'
                  size='large'
                  disabled={disabledFormData}
                >
                  Finish
                </Button>
              </Col>
            </Row>
          </Col>
        </Spin>
      </form>
      {/* <Modal
      title="Bank Account Verification Required"
      open={isModalVisible}
      footer={null}
      closable={false}
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
      >
        {fields.map(({ name, description }) => (
          <Form.Item
            key={name}
            label={name.replace(/_/g, " ").toUpperCase()}
            name={name}
            rules={[{ required: true, message: `${name.replace(/_/g, " ")} is required.` }]}
          >
            <>
              <Input placeholder={`Enter ${name.replace(/_/g, " ")}`} />
              <Text type="danger" style={{ fontSize: 12 }}>{description}</Text>
            </>
          </Form.Item>
        ))}

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal> */}
    </>
  );
};

export default UpdateProductConfiguration;
